import React, {useEffect, useState } from "react";
import Navbar from "@/components/Navbar/Navbar";
import SideMenu from "@/components/MyAccount/SideMenu";
import "react-datepicker/dist/react-datepicker.css";
import {TableBody, TableCell, TableRow} from "@/components/ui/table";
import {ArticleDiscountModel, OrganizationClientsManagementModel} from "@/api/Models";
import ApiHttpClient from "@/HttpClient";
import {toast} from "@/components/ui/use-toast";

const SearchInput: React.FC<any> = ({setSearchClient}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.toLocaleLowerCase().length > 2) {
            setSearchClient(e.target.value.toLowerCase());
        } else {
            setSearchClient("");
        }
    };

    return (
        <input
            className="block w-full rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black"
            type="search"
            onChange={handleChange}
            placeholder="Cauta numele unui client..."
        />
    );
};

export interface ArticleDiscountsListResponse {
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    items: ArticleDiscountModel[]
}

function ClientManagement() {
    const [searchClient, setSearchClient] = useState("");
    const [clientsData, setClientsData] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [inputValue, setInputValue] = useState(currentPage + 1);
    const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);
    const pageSize = 40;

    const handlePageChange = (selectedPage: number) => {
        setCurrentPage(selectedPage);
        // setIsNewSearch(false);
    };
    
    useEffect(() => {
        const clientsList = async () => {
            let response;
            
            if(searchClient) {
                response = await ApiHttpClient().post<OrganizationClientsManagementModel>(`/organization/search`, {
                    "advancedSearch": {
                        "fields": [
                            "name"
                        ],
                        "keyword": searchClient
                    },
                    "pageNumber": currentPage + 1,
                    "pageSize": pageSize,
                });
            } else {
                response = await ApiHttpClient().post<OrganizationClientsManagementModel>(`/organization/search`, {
                    "pageNumber": currentPage + 1,
                    "pageSize": pageSize,
                });
            }
            if (!response?.data) {
                toast({description: "A aparut o eroare pentru afisarea articolelor"});
                return <></>;
            }
            setClientsData(response.data);
        }
        clientsList();
    }, [searchClient, currentPage, pageSize]);

    useEffect(() => {
        setInputValue(currentPage + 1);
    }, [currentPage]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = Number(e.target.value);

        if (clientsData?.totalPages && value > clientsData.totalPages) {
            value = clientsData.totalPages;
        } else if (value < 1) {
            value = 1;
        }
        setInputValue(value);

        if (debounceTimer) clearTimeout(debounceTimer);

        const timer = setTimeout(() => {
            if (clientsData?.totalPages && value >= 1 && value <= clientsData?.totalPages) {
                handlePageChange(value - 1);
            }
        }, 500);

        setDebounceTimer(timer);
    };

    return (
        <>
            <Navbar />
            <div className="flex flex-row items-start">
                <SideMenu />
                <div className="flex flex-col overflow-auto w-full">
                    <div className="text-4xl px-8 py-3 mt-5">Administrare Conditii Contractuale</div>
                    <div className="overflow-x-auto px-8 py-2 mt-2">
                        <SearchInput setSearchClient={setSearchClient}/>
                        <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm mt-4">
                            <thead className="text-left">
                            <tr>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">Cod Client</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">Nume Client</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">Tip Client</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">Configurat</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">Actiune</th>
                            </tr>
                            </thead>

                            <TableBody>
                                {clientsData.items && clientsData.items.length > 0 && clientsData.items.map((client: OrganizationClientsManagementModel, index: number) => {
                                    return (
                                        <TableRow key={client.id}
                                                  className={index % 2 === 0 ? "bg-slate-150" : "bg-slate-100"}>
                                            <TableCell
                                                className="text-left whitespace-nowrap px-4 py-2 font-medium text-gray-900">{client.id}</TableCell>
                                            <TableCell className=" whitespace-nowrap px-4 py-2 text-gray-700">
                                                {client.name}
                                            </TableCell>
                                            <TableCell className=" whitespace-nowrap px-4 py-2 text-gray-700">
                                                {client.organizationUC}
                                            </TableCell>
                                            <TableCell className=" whitespace-nowrap px-4 py-2 text-gray-700">
                                                <label>
                                                    <input type="checkbox" checked={client.isCreditLimitActive}
                                                           className="sr-only peer" disabled/>
                                                    <div
                                                        className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                                                </label>
                                            </TableCell>
                                            <TableCell
                                                className=" whitespace-nowrap px-4 py-2 text-gray-700">
                                                <a href={"/client-organization/" + client.id}>
                                                    <button
                                                        className="border-2 px-2 border-blue-300 rounded-lg bg-blue-100"
                                                    >Acceseaza
                                                    </button>
                                                </a>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                            </TableBody>

                        </table>
                    </div>

                    <ul className="flex justify-center gap-1 text-gray-900 my-3">
                        <li>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage > 0) handlePageChange(currentPage - 1);
                                }}
                                className="grid mr-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                aria-label="Previous page"
                                disabled={currentPage === 0}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="size-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>
                        </li>

                        <li>
                            <label htmlFor="Page" className="flex items-center gap-1">
                                <span className="sr-only">Pagina</span>
                                <input
                                    type="number"
                                    id="Page"
                                    value={inputValue}
                                    min={1}
                                    max={clientsData.totalPages}
                                    onChange={handleInputChange}
                                    className="h-8 w-10 rounded border-gray-300 text-center sm:text-sm"
                                />
                                <span className="text-sm">/ {clientsData.totalPages}</span>
                            </label>
                        </li>

                        <li>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage < clientsData.totalPages - 1) handlePageChange(currentPage + 1);
                                }}
                                className="grid ml-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                aria-label="Next page"
                                disabled={currentPage === clientsData.totalPages - 1}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="size-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>
                        </li>
                    </ul>

                </div>
            </div>
        </>
    );
}

export default ClientManagement;
